module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/new-window-8e35ab95837b1204b62535d3dd72f53d.svg";